import React from 'react';
import { useStyles } from '../style';

export const ID_RESULTS_FOUND: string = 'xnuupPartId-autocomplete-results-found';
export const ID_LOADING: string = 'xnuupPartId-autocomplete-loading';

export const ListBoxXnuupPartIdComponent = (params: any) => {
  // Styles
  const classes = useStyles();

  return (
    <>
      <div className={classes.containerResultsFound}>
        {params.textResultFound}
      </div>
      <ul {...params} style={{ padding: 0, maxHeight: 300 }} />
      <div className={classes.containerLoading} >
        {params.isLoading && params.textIsLoading}
      </div>
    </>
  );
};
